module.exports = __webpack_public_path__ + "media/images/vp/icon.notifications.red-e4eceed7ab6d3f0b6dfd9607977999bd.svg";